// Team Shell — Profile page (frontend/src/pages/artist/Profile.jsx)
// All keys are prefixed with `dash.profile.`
const shellProfile = {
  en: {
    "dash.profile.title": "Profile & Settings",
    "dash.profile.subtitle": "Manage your account information and preferences",
    "dash.profile.edit": "Edit Profile",
    "dash.profile.cancel": "Cancel",
    "dash.profile.save": "Save Changes",
    "dash.profile.notSet": "Not set",

    "dash.profile.personalInfo": "Personal Information",
    "dash.profile.personalInfoDesc": "Your name and account details",
    "dash.profile.firstName": "First Name",
    "dash.profile.lastName": "Last Name",
    "dash.profile.email": "Email Address",
    "dash.profile.accountStatus": "Account Status",
    "dash.profile.suspensionReason": "Suspension Reason",

    "dash.profile.contactAddress": "Contact & Address",
    "dash.profile.contactAddressDesc": "Used for payouts and official correspondence",
    "dash.profile.fullAddress": "Full Address",
    "dash.profile.addressPlaceholder": "Address line",
    "dash.profile.city": "City",
    "dash.profile.country": "Country",
    "dash.profile.postalCode": "Postal Code",

    "dash.profile.labelSettings": "Label Settings",
    "dash.profile.labelSettingsDesc": "Brand identity shown on your releases",
    "dash.profile.labelPartner": "Label Partner",
    "dash.profile.labelName": "Label Name",
    "dash.profile.labelDescription": "Description",
    "dash.profile.labelDescriptionPlaceholder": "Brief description about your label...",
    "dash.profile.logoHint": "PNG, JPG (Max 2MB)",
    "dash.profile.avatarHint": "PNG, JPG · Max 5MB",

    "dash.profile.webSocial": "Web & Social Media",
    "dash.profile.social.website": "Website",
    "dash.profile.social.instagram": "Instagram",
    "dash.profile.social.twitter": "Twitter",
    "dash.profile.social.youtube": "YouTube",
    "dash.profile.placeholder.website": "https://...",
    "dash.profile.placeholder.username": "@username",
    "dash.profile.placeholder.channel": "Channel URL",

    "dash.profile.currentPlan": "Current Plan",
    "dash.profile.plan.free": "Free",
    "dash.profile.plan.artist": "Artist",
    "dash.profile.plan.pro": "Pro",
    "dash.profile.plan.label": "Label",
    "dash.profile.joined": "Joined",
    "dash.profile.releases": "Releases",
    "dash.profile.approvedReleases": "Approved",

    "dash.profile.financialSummary": "Financial Summary",
    "dash.profile.totalBalance": "Total Balance",
    "dash.profile.withdrawable": "Withdrawable",

    "dash.profile.changePassword": "Change Password",
    "dash.profile.changePasswordDesc": "Use a strong password you don't use elsewhere",
    "dash.profile.currentPassword": "Current Password",
    "dash.profile.newPassword": "New Password",
    "dash.profile.confirmPassword": "Confirm Password",
    "dash.profile.updatePassword": "Update Password",
    "dash.profile.lastLogin": "Last Login",

    "dash.profile.status.pending": "Pending Approval",
    "dash.profile.status.approved": "Approved",
    "dash.profile.status.rejected": "Rejected",
    "dash.profile.status.suspended": "Suspended",

    "dash.profile.loadErrorTitle": "Couldn't load your profile",
    "dash.profile.loadErrorDesc": "Check your connection and try again.",

    "dash.profile.toast.loadFailed": "Failed to load profile",
    "dash.profile.toast.updated": "Profile updated",
    "dash.profile.toast.updateFailed": "Update failed",
    "dash.profile.toast.passwordMismatch": "Passwords do not match",
    "dash.profile.toast.passwordUpdated": "Password updated",
    "dash.profile.toast.passwordFailed": "Failed to update password",
    "dash.profile.toast.onlyImages": "Only image files are allowed",
    "dash.profile.toast.maxSize2": "File size must be less than 2MB",
    "dash.profile.toast.maxSize5": "File size must be less than 5MB",
    "dash.profile.toast.logoUploaded": "Logo uploaded",
    "dash.profile.toast.logoUploadFailed": "Failed to upload logo",
    "dash.profile.toast.logoDeleted": "Logo deleted",
    "dash.profile.toast.logoDeleteFailed": "Failed to delete logo",
    "dash.profile.toast.avatarUpdated": "Profile photo updated",
    "dash.profile.toast.avatarUploadFailed": "Upload failed",
    "dash.profile.toast.avatarDeleted": "Profile photo deleted",
    "dash.profile.toast.avatarDeleteFailed": "Failed to delete photo",

    "dash.profile.aria.changeAvatar": "Change profile photo",
    "dash.profile.aria.deleteAvatar": "Delete profile photo",
    "dash.profile.aria.uploadLogo": "Upload label logo",
    "dash.profile.aria.deleteLogo": "Delete label logo",
    "dash.profile.alt.avatar": "Profile photo",
    "dash.profile.alt.logo": "Label logo",
  },
  tr: {
    "dash.profile.title": "Profil & Ayarlar",
    "dash.profile.subtitle": "Hesap bilgilerinizi ve tercihlerinizi yönetin",
    "dash.profile.edit": "Profili Düzenle",
    "dash.profile.cancel": "İptal",
    "dash.profile.save": "Değişiklikleri Kaydet",
    "dash.profile.notSet": "Belirtilmemiş",

    "dash.profile.personalInfo": "Kişisel Bilgiler",
    "dash.profile.personalInfoDesc": "Adınız ve hesap detaylarınız",
    "dash.profile.firstName": "Ad",
    "dash.profile.lastName": "Soyad",
    "dash.profile.email": "E-posta Adresi",
    "dash.profile.accountStatus": "Hesap Durumu",
    "dash.profile.suspensionReason": "Askı Sebebi",

    "dash.profile.contactAddress": "İletişim & Adres",
    "dash.profile.contactAddressDesc": "Ödemeler ve resmi yazışmalar için kullanılır",
    "dash.profile.fullAddress": "Tam Adres",
    "dash.profile.addressPlaceholder": "Adres satırı",
    "dash.profile.city": "Şehir",
    "dash.profile.country": "Ülke",
    "dash.profile.postalCode": "Posta Kodu",

    "dash.profile.labelSettings": "Label Ayarları",
    "dash.profile.labelSettingsDesc": "Yayınlarınızda görünen marka kimliği",
    "dash.profile.labelPartner": "Label Partneri",
    "dash.profile.labelName": "Label / Marka Adı",
    "dash.profile.labelDescription": "Hakkında",
    "dash.profile.labelDescriptionPlaceholder": "Şirketiniz hakkında kısa bir açıklama yazın...",
    "dash.profile.logoHint": "PNG, JPG (Maks. 2MB)",
    "dash.profile.avatarHint": "PNG, JPG · Maks. 5MB",

    "dash.profile.webSocial": "Web & Sosyal Medya",
    "dash.profile.social.website": "Web Sitesi",
    "dash.profile.social.instagram": "Instagram",
    "dash.profile.social.twitter": "Twitter",
    "dash.profile.social.youtube": "YouTube",
    "dash.profile.placeholder.website": "https://...",
    "dash.profile.placeholder.username": "@kullaniciadi",
    "dash.profile.placeholder.channel": "Kanal URL'si",

    "dash.profile.currentPlan": "Mevcut Plan",
    "dash.profile.plan.free": "Ücretsiz",
    "dash.profile.plan.artist": "Artist",
    "dash.profile.plan.pro": "Pro",
    "dash.profile.plan.label": "Label",
    "dash.profile.joined": "Kayıt",
    "dash.profile.releases": "Yayınlar",
    "dash.profile.approvedReleases": "Onaylı",

    "dash.profile.financialSummary": "Finansal Özet",
    "dash.profile.totalBalance": "Toplam Bakiye",
    "dash.profile.withdrawable": "Çekilebilir",

    "dash.profile.changePassword": "Şifre Değiştir",
    "dash.profile.changePasswordDesc": "Başka yerde kullanmadığınız güçlü bir şifre seçin",
    "dash.profile.currentPassword": "Mevcut Şifre",
    "dash.profile.newPassword": "Yeni Şifre",
    "dash.profile.confirmPassword": "Yeni Şifre (Tekrar)",
    "dash.profile.updatePassword": "Şifreyi Güncelle",
    "dash.profile.lastLogin": "Son Giriş",

    "dash.profile.status.pending": "Onay Bekliyor",
    "dash.profile.status.approved": "Onaylandı",
    "dash.profile.status.rejected": "Reddedildi",
    "dash.profile.status.suspended": "Askıya Alındı",

    "dash.profile.loadErrorTitle": "Profiliniz yüklenemedi",
    "dash.profile.loadErrorDesc": "Bağlantınızı kontrol edip tekrar deneyin.",

    "dash.profile.toast.loadFailed": "Profil yüklenemedi",
    "dash.profile.toast.updated": "Profil güncellendi",
    "dash.profile.toast.updateFailed": "Güncelleme başarısız",
    "dash.profile.toast.passwordMismatch": "Şifreler eşleşmiyor",
    "dash.profile.toast.passwordUpdated": "Şifre güncellendi",
    "dash.profile.toast.passwordFailed": "Şifre güncellenemedi",
    "dash.profile.toast.onlyImages": "Sadece resim dosyaları yüklenebilir",
    "dash.profile.toast.maxSize2": "Dosya boyutu 2MB'dan küçük olmalı",
    "dash.profile.toast.maxSize5": "Dosya boyutu 5MB'dan küçük olmalı",
    "dash.profile.toast.logoUploaded": "Logo yüklendi",
    "dash.profile.toast.logoUploadFailed": "Logo yüklenemedi",
    "dash.profile.toast.logoDeleted": "Logo silindi",
    "dash.profile.toast.logoDeleteFailed": "Logo silinemedi",
    "dash.profile.toast.avatarUpdated": "Profil fotoğrafı güncellendi",
    "dash.profile.toast.avatarUploadFailed": "Fotoğraf yüklenemedi",
    "dash.profile.toast.avatarDeleted": "Profil fotoğrafı silindi",
    "dash.profile.toast.avatarDeleteFailed": "Fotoğraf silinemedi",

    "dash.profile.aria.changeAvatar": "Profil fotoğrafını değiştir",
    "dash.profile.aria.deleteAvatar": "Profil fotoğrafını sil",
    "dash.profile.aria.uploadLogo": "Label logosu yükle",
    "dash.profile.aria.deleteLogo": "Label logosunu sil",
    "dash.profile.alt.avatar": "Profil fotoğrafı",
    "dash.profile.alt.logo": "Label logosu",
  },
  es: {
    "dash.profile.title": "Perfil y Ajustes",
    "dash.profile.subtitle": "Gestiona la información y preferencias de tu cuenta",
    "dash.profile.edit": "Editar perfil",
    "dash.profile.cancel": "Cancelar",
    "dash.profile.save": "Guardar cambios",
    "dash.profile.notSet": "Sin definir",

    "dash.profile.personalInfo": "Información personal",
    "dash.profile.personalInfoDesc": "Tu nombre y los datos de tu cuenta",
    "dash.profile.firstName": "Nombre",
    "dash.profile.lastName": "Apellido",
    "dash.profile.email": "Correo electrónico",
    "dash.profile.accountStatus": "Estado de la cuenta",
    "dash.profile.suspensionReason": "Motivo de la suspensión",

    "dash.profile.contactAddress": "Contacto y dirección",
    "dash.profile.contactAddressDesc": "Se usa para pagos y comunicaciones oficiales",
    "dash.profile.fullAddress": "Dirección completa",
    "dash.profile.addressPlaceholder": "Línea de dirección",
    "dash.profile.city": "Ciudad",
    "dash.profile.country": "País",
    "dash.profile.postalCode": "Código postal",

    "dash.profile.labelSettings": "Ajustes del sello",
    "dash.profile.labelSettingsDesc": "Identidad de marca que aparece en tus lanzamientos",
    "dash.profile.labelPartner": "Sello asociado",
    "dash.profile.labelName": "Nombre del sello",
    "dash.profile.labelDescription": "Descripción",
    "dash.profile.labelDescriptionPlaceholder": "Breve descripción de tu sello...",
    "dash.profile.logoHint": "PNG, JPG (Máx. 2MB)",
    "dash.profile.avatarHint": "PNG, JPG · Máx. 5MB",

    "dash.profile.webSocial": "Web y redes sociales",
    "dash.profile.social.website": "Sitio web",
    "dash.profile.social.instagram": "Instagram",
    "dash.profile.social.twitter": "Twitter",
    "dash.profile.social.youtube": "YouTube",
    "dash.profile.placeholder.website": "https://...",
    "dash.profile.placeholder.username": "@usuario",
    "dash.profile.placeholder.channel": "URL del canal",

    "dash.profile.currentPlan": "Plan actual",
    "dash.profile.plan.free": "Gratis",
    "dash.profile.plan.artist": "Artist",
    "dash.profile.plan.pro": "Pro",
    "dash.profile.plan.label": "Label",
    "dash.profile.joined": "Miembro desde",
    "dash.profile.releases": "Lanzamientos",
    "dash.profile.approvedReleases": "Aprobados",

    "dash.profile.financialSummary": "Resumen financiero",
    "dash.profile.totalBalance": "Saldo total",
    "dash.profile.withdrawable": "Disponible para retirar",

    "dash.profile.changePassword": "Cambiar contraseña",
    "dash.profile.changePasswordDesc": "Usa una contraseña segura que no uses en otros sitios",
    "dash.profile.currentPassword": "Contraseña actual",
    "dash.profile.newPassword": "Nueva contraseña",
    "dash.profile.confirmPassword": "Confirmar contraseña",
    "dash.profile.updatePassword": "Actualizar contraseña",
    "dash.profile.lastLogin": "Último acceso",

    "dash.profile.status.pending": "Pendiente de aprobación",
    "dash.profile.status.approved": "Aprobada",
    "dash.profile.status.rejected": "Rechazada",
    "dash.profile.status.suspended": "Suspendida",

    "dash.profile.loadErrorTitle": "No se pudo cargar tu perfil",
    "dash.profile.loadErrorDesc": "Comprueba tu conexión e inténtalo de nuevo.",

    "dash.profile.toast.loadFailed": "No se pudo cargar el perfil",
    "dash.profile.toast.updated": "Perfil actualizado",
    "dash.profile.toast.updateFailed": "Error al actualizar",
    "dash.profile.toast.passwordMismatch": "Las contraseñas no coinciden",
    "dash.profile.toast.passwordUpdated": "Contraseña actualizada",
    "dash.profile.toast.passwordFailed": "No se pudo actualizar la contraseña",
    "dash.profile.toast.onlyImages": "Solo se permiten archivos de imagen",
    "dash.profile.toast.maxSize2": "El archivo debe pesar menos de 2MB",
    "dash.profile.toast.maxSize5": "El archivo debe pesar menos de 5MB",
    "dash.profile.toast.logoUploaded": "Logo subido",
    "dash.profile.toast.logoUploadFailed": "No se pudo subir el logo",
    "dash.profile.toast.logoDeleted": "Logo eliminado",
    "dash.profile.toast.logoDeleteFailed": "No se pudo eliminar el logo",
    "dash.profile.toast.avatarUpdated": "Foto de perfil actualizada",
    "dash.profile.toast.avatarUploadFailed": "Error al subir la foto",
    "dash.profile.toast.avatarDeleted": "Foto de perfil eliminada",
    "dash.profile.toast.avatarDeleteFailed": "No se pudo eliminar la foto",

    "dash.profile.aria.changeAvatar": "Cambiar foto de perfil",
    "dash.profile.aria.deleteAvatar": "Eliminar foto de perfil",
    "dash.profile.aria.uploadLogo": "Subir logo del sello",
    "dash.profile.aria.deleteLogo": "Eliminar logo del sello",
    "dash.profile.alt.avatar": "Foto de perfil",
    "dash.profile.alt.logo": "Logo del sello",
  },
};

export default shellProfile;
